const moduleAndBase = '/permisos-sindicales/labor-unions'
const paths = {
  me: moduleAndBase.concat('/me')
  , setting: moduleAndBase.concat('/:id/settings/:key')
}

export { paths }